import { FC, memo, useState } from 'react'

import { TopicOverview } from '~/types/theory'
import { getTopicClassName, childrenIsTexContent } from '~/encyclopedia/utils/encyclopedia.utils'

import { SubTopicItem } from './SubTopicItem'

interface SubTopicsProps {
  subTopics: TopicOverview[]
}

const SubTopicsComponent: FC<SubTopicsProps> = ({ subTopics }) => {
  const [itemSubTopics, setItemSubTopics] = useState<TopicOverview[]>([])
  const [showSubTopics, setShowSubTopics] = useState(false)
  const [activeClass, setActiveClass] = useState({ path: '', className: '' })
  const handleOnMouseLeave = (): void => {
    setItemSubTopics([])
    setShowSubTopics(false)
    setActiveClass({ path: '', className: '' })
  }

  const handleOnMouseEnter = (topic: TopicOverview): void => {
    if (topic.children) {
      setItemSubTopics(topic.children)
      setShowSubTopics(true)
    }

    setActiveClass({
      path: topic.path,
      className: getTopicClassName(topic),
    })
  }

  return (
    <div className="flex pl-4" onMouseLeave={handleOnMouseLeave}>
      <div className={`${childrenIsTexContent(subTopics) ? 'shrink' : 'shrink-0'} flex flex-col`}>
        {subTopics.map((topic) => (
          <SubTopicItem
            activeClassName={activeClass.path === topic.path ? activeClass.className : ''}
            key={topic.path}
            onMouseEnter={handleOnMouseEnter}
            topic={topic}
          />
        ))}
      </div>
      {showSubTopics && <SubTopics subTopics={itemSubTopics} />}
    </div>
  )
}
export const SubTopics = memo(SubTopicsComponent)
